<template>
    <div class="home-page">
        <AnimatedContent :distance="28" :duration="0.7" :delay="0.05">
            <section class="home-banner">
                <Swipe class="home-banner__swipe" :autoplay="4000" :loop="true" :show-indicators="false"
                    @change="onBannerChange">
                    <SwipeItem v-for="(item, index) in banners" :key="index">
                        <img class="home-banner__bg" :src="item.img" alt="">
                        <div class="home-banner__copy">
                            <ShinyText className="home-banner__brand" :text="$t('home.brand')" :speed="4" />
                            <SplitText v-if="bannerIndex === index" className="home-banner__slogan"
                                :text="$t('home.slogan')" textAlign="left" splitType="words" :delay="40" :duration="0.5"
                                rootMargin="0px" />
                            <div v-else class="home-banner__slogan">{{ $t('home.slogan') }}</div>
                            <div class="home-banner__desc">{{ $t('home.sloganDesc') }}</div>
                        </div>
                        <div class="home-banner__yield">
                            <ShinyText :text="$t('home.yield')" :speed="3" className="home-banner__yield-label" />
                            <strong>+
                                <NumberScroll :to="item.yield" :decimal="true" :decimal-digits="2" :duration="1.6" />%
                            </strong>
                        </div>
                    </SwipeItem>
                </Swipe>
                <div class="home-banner__dots">
                    <i v-for="(item, index) in banners" :key="'dot-' + index"
                        :class="{ active: bannerIndex === index }"></i>
                </div>
            </section>
        </AnimatedContent>

        <FadeContent :delay="120" :duration="700">
            <div class="home-notice" @click="$router.push({ name: 'notice',query:{id:noticeID} })">
                <img src="@/assets/img/home/bell.png" alt="">
                <span>{{ noticeTitle }}</span>
                <img class="home-notice__chevron" src="@/assets/img/home/chevron.png" alt="">
            </div>
        </FadeContent>

        <div class="home-stats">
            <AnimatedContent className="home-stats__output" :distance="24" :duration="0.65" :delay="0.08">
                <div class="home-stats__output-inner">
                    <img src="@/assets/img/home/card-output.png" alt="">
                    <div class="home-stats__copy home-stats__copy--light">
                        <div class="home-stats__label">
                            {{ $t('home.todayOutput') }}
                            <em>(FOVO)</em>
                        </div>
                        <div class="home-stats__value home-stats__value--lg">
                            <NumberScroll :to="poolAmount" separator="," :duration="1.1" />
                        </div>
                    </div>
                </div>
            </AnimatedContent>
            <AnimatedContent className="home-stats__hashrate" :distance="24" :duration="0.65" :delay="0.16">
                <div class="home-stats__hashrate-inner">
                    <img class="home-stats__hashrate-img" src="@/assets/img/home/card-hashrate.png" alt="">
                    <div class="home-stats__copy">
                        <div class="home-stats__label">
                            {{ $t('home.networkHashrate') }}
                            <em>(T)</em>
                        </div>
                        <div class="home-stats__value">
                            <NumberScroll :to="allPower" :decimal="true" :decimal-digits="2" :duration="1.6" />
                        </div>
                    </div>
                </div>
            </AnimatedContent>
        </div>

        <div class="home-mini">
            <AnimatedContent className="home-mini__card" :distance="20" :duration="0.6" :delay="0.12">
                <div class="home-mini__card-inner">
                    <img src="@/assets/img/home/card-price.png" alt="">
                    <div class="home-mini__copy">
                        <div class="home-stats__label">
                            {{ $t('home.price') }}
                            <em>(USDT)</em>
                        </div>
                        <div class="home-stats__value">
                            <NumberScroll :to="abcPrice" :decimal="true" :decimal-digits="2" :duration="1.4" />
                        </div>
                    </div>
                </div>
            </AnimatedContent>
            <AnimatedContent className="home-mini__card" :distance="20" :duration="0.6" :delay="0.2">
                <div class="home-mini__card-inner">
                    <img src="@/assets/img/home/card-price.png" alt="">
                    <div class="home-mini__copy">
                        <div class="home-stats__label">
                            {{ $t('home.burned') }}
                            <em>(FOVO)</em>
                        </div>
                        <div class="home-stats__value">
                            <NumberScroll :to="deadAmount" :decimal="true" :decimal-digits="2" :duration="1.4" />
                        </div>
                    </div>
                </div>
            </AnimatedContent>
        </div>

        <FadeContent :blur="true" :delay="80" :duration="800">
            <section class="home-about">
                <h2>{{ $t('home.aboutTitle') }}</h2>
                <p>{{ $t('home.aboutDesc') }}</p>
            </section>
        </FadeContent>

        <AnimatedContent :distance="24" :duration="0.7" :delay="0.05">
            <div class="home-feature home-feature--row">
                <img src="@/assets/img/home/icon-hashrate.png" alt="">
                <div>
                    <h3>{{ $t('home.featureHashrate') }}</h3>
                    <p>{{ $t('home.featureHashrateDesc') }}</p>
                </div>
            </div>
        </AnimatedContent>

        <div class="home-feature-grid">
            <AnimatedContent className="home-feature" :distance="28" :duration="0.7" :delay="0.08">
                <img src="@/assets/img/home/icon-daily.png" alt="">
                <h3>{{ $t('home.featureDaily') }}</h3>
                <p>{{ $t('home.featureDailyDesc') }}</p>
            </AnimatedContent>
            <AnimatedContent className="home-feature" :distance="28" :duration="0.7" :delay="0.16">
                <img src="@/assets/img/home/icon-security.png" alt="">
                <h3>{{ $t('home.featureSecurity') }}</h3>
                <p>{{ $t('home.featureSecurityDesc') }}</p>
            </AnimatedContent>
        </div>

        <Popup
            v-model="bindShow"
            get-container="#app"
            class="home-bind-popup"
            :overlay-style="{ background: 'rgba(16, 17, 38, 0.5)' }"
        >
            <div class="home-bind">
                <button class="home-bind__close" type="button" @click="bindShow = false">
                    <img src="@/assets/img/mining/icon-close.png" alt="">
                </button>
                <img class="home-bind__illus" src="@/assets/img/home/bind-illus.png" alt="">
                <h3>{{ $t('home.bindTitle') }}</h3>
                <div class="home-bind__field">
                    <img src="@/assets/img/home/bind-wallet.png" alt="">
                    <input v-model="inviteAddress" :placeholder="$t('home.bindPlaceholder')">
                </div>
                <button class="home-bind__btn" type="button" @click="bindShow = false">
                    {{ $t('home.bindConfirm') }}
                </button>
            </div>
        </Popup>
    </div>
</template>

<script>
import { Popup, Swipe, SwipeItem } from 'vant';
import AnimatedContent from '@/components/AnimatedContent/AnimatedContent.vue';
import FadeContent from '@/components/FadeContent/FadeContent.vue';
import SplitText from '@/components/SplitText/SplitText.vue';
import ShinyText from '@/components/ShinyText/ShinyText.vue';
import NumberScroll from '@/components/NumberScroll.vue';

import axios from 'axios'
import contractaa from '../contract/index.js';
import Web3 from 'web3'
let web3
web3 = new Web3(window.ethereum);

export default {
    name: 'home-page',
    components: {
        Popup,
        Swipe,
        SwipeItem,
        AnimatedContent,
        FadeContent,
        SplitText,
        ShinyText,
        NumberScroll,
    },
    data() {
        return {
            bindShow: false,
            inviteAddress: '0x0000000000000000000000',
            bannerIndex: 0,
            banners: [
                { yield: 2.86, img: require('@/assets/img/home/banner.png') },
                { yield: 3.12, img: require('@/assets/img/home/banner.png') },
                { yield: 2.45, img: require('@/assets/img/home/banner.png') },
                { yield: 2.91, img: require('@/assets/img/home/banner.png') },
                { yield: 3.08, img: require('@/assets/img/home/banner.png') },
            ],
            abcPrice:0,
            poolAmount:0,
            allPower:0,
            deadAmount:0,
            noticeTitle:'',
            noticeID:0,
        };
    },
    methods: {
        onBannerChange(index) {
            this.bannerIndex = index;
        },
        async getInfo(){
            let that = this
            let useraddr = this.$store.state.globalAddress

            let axiosResult = await axios.post(contractaa.APIURL+'?cmd=home','addr='+useraddr);
            if(axiosResult.status == 200){
                if(axiosResult.data.Status){
                    let _arr = axiosResult.data.Message.split('|')
                    that.poolAmount = Number(_arr[0])
                    that.allPower = Number(_arr[1])
                    that.abcPrice =Number(_arr[2])

                    that.noticeTitle = axiosResult.data.Data[0].Title
                    that.noticeID = axiosResult.data.Data[0].ID

                }
            }
            let deadAddress = '0x000000000000000000000000000000000000dEaD'
            let dolContract = new web3.eth.Contract(contractaa.abiABC,contractaa.abcToken)
            let deaddoAmount = await dolContract.methods.balanceOf(deadAddress).call()
            let dead1 = web3.utils.fromWei(deaddoAmount,'ether')
            that.deadAmount = Number(dead1)
            
        },
    },
    mounted(){
        this.getInfo()
    }
};
</script>

<style lang="less" scoped>
.home-page {
    padding: 8px 16px 12px;
    color: #101126;
}

.home-banner {
    position: relative;
    height: 168px;
    border-radius: 14px;
    overflow: hidden;

    &__swipe {
        height: 168px;
        border-radius: 14px;
    }

    /deep/ .van-swipe,
    /deep/ .van-swipe-item {
        height: 168px;
    }

    /deep/ .van-swipe-item {
        position: relative;
    }

    &__bg {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    &__copy {
        position: absolute;
        left: 15px;
        top: 40px;
        width: 167px;
        pointer-events: none;
    }

    &__brand {
        font-size: 18px;
        font-weight: 700;
        line-height: 20px;
        color: #101126;
        font-style: italic;
    }

    &__slogan {
        margin-top: 4px;
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
        color: #101126;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    &__desc {
        margin-top: 6px;
        font-size: 14px;
        line-height: 20px;
        color: #101126;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__yield {
        position: absolute;
        right: 15px;
        bottom: 22px;
        width: 76px;
        height: 39px;
        padding: 2px 8px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;

        span,
        .home-banner__yield-label {
            font-size: 12px;
            color: #FFFFFF;
            line-height: 17px;
        }

        strong {
            font-size: 16px;
            font-weight: 600;
            color: #FDF507;
            line-height: 22px;
        }
    }

    &__dots {
        position: absolute;
        left: 50%;
        bottom: 10px;
        z-index: 2;
        transform: translateX(-50%);
        display: flex;
        align-items: center;

        i {
            width: 5px;
            height: 5px;
            margin: 0 2px;
            border-radius: 50%;
            background: rgba(16, 17, 38, 0.2);

            &.active {
                background: #101126;
            }
        }
    }
}

.home-notice {
    margin-top: 10px;
    height: 40px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-radius: 14px;

    img {
        width: 22px;
        height: 22px;
    }

    span {
        flex: 1;
        margin: 0 8px;
        font-size: 12px;
        color: #101126;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__chevron {
        width: 12px !important;
        height: 12px !important;
    }
}

.home-stats {
    margin-top: 10px;
    display: flex;
    gap: 10px;

    &__output,
    &__hashrate {
        position: relative;
        overflow: hidden;
        border-radius: 14px;
    }

    &__output-inner,
    &__hashrate-inner {
        height: 100%;
        position: relative;
    }

    &__output {
        width: 213px;
        height: 120px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    &__hashrate {
        flex: 1;
        height: 120px;
        background: #FFFFFF;

        .home-stats__copy {
            right: 8px;
        }

        &-img {
            position: absolute;
            right: 0;
            bottom: 0;
            object-fit: contain;
            pointer-events: none;
        }
    }

    &__copy {
        position: absolute;
        left: 15px;
        top: 12px;
        right: 10px;

        &--light {

            .home-stats__label,
            .home-stats__label em,
            .home-stats__value {
                color: #FFFFFF;
            }

            .home-stats__value {
                font-size: 28px;
                line-height: 32px;
            }
        }
    }

    &__label {
        font-size: 12px;
        line-height: 17px;
        color: #101126;
        opacity: 0.7;
        white-space: nowrap;

        em {
            font-style: normal;
            opacity: 0.5;
            margin-left: 4px;
        }
    }

    &__value {
        margin-top: 6px;
        font-family: DINAlternate-Bold, sans-serif;
        font-size: 24px;
        line-height: 28px;
        font-weight: 700;
        color: #101126;

        &--lg {
            font-size: 28px;
            line-height: 32px;
        }
    }
}

.home-mini {
    margin-top: 10px;
    display: flex;
    gap: 10px;

    &__card {
        position: relative;
        flex: 1;
        height: 77px;
        border-radius: 14px;
        overflow: hidden;
        background: #FFFFFF;

        .home-mini__card-inner {
            height: 100%;
            position: relative;
        }

        img {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__copy {
        position: relative;
        z-index: 1;
        padding: 12px 15px 0;
    }
}

.home-about {
    margin-top: 10px;
    padding: 15px;
    background: #FFFFFF;
    border-radius: 14px;

    h2 {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #101126;
    }

    p {
        margin-top: 5px;
        font-size: 12px;
        line-height: 19px;
        color: #101126;
        opacity: 0.5;
    }
}

.home-feature {
    background: #FFFFFF;
    border-radius: 14px;
    padding: 14px 15px 15px;

    img {
        width: 42px;
        height: 42px;
        display: block;
    }

    h3 {
        margin-top: 8px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
    }

    p {
        margin-top: 3px;
        font-size: 12px;
        line-height: 19px;
        color: #101126;
        opacity: 0.5;
    }

    &--row {
        margin-top: 10px;
        height: 70px;
        padding: 14px 15px;
        display: flex;
        align-items: center;

        img {
            margin-right: 8px;
        }

        h3 {
            margin-top: 0;
        }
    }
}

.home-feature-grid {
    margin-top: 10px;
    display: flex;
    gap: 12px;

    .home-feature {
        flex: 1;
        min-height: 143px;
    }
}

.home-bind-popup {
    width: 270px;
    overflow: hidden;
    background: #F3F2ED;
    border-radius: 14px;
    padding: 0;
}

.home-bind {
    position: relative;
    width: 270px;
    height: 278px;
    padding: 7px 20px 20px;
    box-sizing: border-box;
    color: #101126;
    background-color: #F3F2ED;
    background-image: radial-gradient(circle at 4.3% 4.3%, #FDFCF8 0%, rgba(255, 255, 255, 0) 44%),
        linear-gradient(204deg, #FFFAE3 0%, #F3F2ED 96%);
    box-shadow: inset 0 1px 0 0 #FFFFFF;
    border-radius: 14px;

    &__close {
        position: absolute;
        right: 15px;
        top: 15px;
        z-index: 2;
        width: 16px;
        height: 16px;
        padding: 0;
        border: 0;
        background: transparent;
        line-height: 0;

        img {
            width: 16px;
            height: 16px;
        }
    }

    &__illus {
        display: block;
        width: 116px;
        height: 116px;
        margin: 0 auto;
        object-fit: contain;
    }

    h3 {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #101126;
    }

    &__field {
        margin-top: 5px;
        width: 230px;
        height: 40px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #FFEA8A;
        border-radius: 10px;

        img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
            flex-shrink: 0;
        }

        input {
            flex: 1;
            min-width: 0;
            border: 0;
            outline: none;
            background: transparent;
            font-size: 12px;
            line-height: 17px;
            color: #101126;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    &__btn {
        margin-top: 20px;
        width: 230px;
        height: 40px;
        border: 0;
        border-radius: 10px;
        background-image: linear-gradient(-57deg, #FEC612 0%, #FFEC47 45%, #FED937 100%);
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        color: #101126;
    }
}
</style>
